import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { ResetPasswordRequestVO } from "./resetpassword.model";
import { ProfileService } from './profile.service';
import { environment } from "../../environments/environment"
import { ApplicationError } from '../common/error.model';
import { HttpService } from '../http/http.service';
import { SsoService } from '../sso/sso.service';
import { SsoTokenVO, UserVO } from '../sso/sso.models';

@Injectable()
export class ProfileServiceImpl implements ProfileService {
  
  constructor(private httpService: HttpService,
    private ssoService: SsoService) { }

  resetPassword(resetPasswordRequestVO: ResetPasswordRequestVO): Promise<void> {
    let url = `${environment.SSO_API_ENDPOINT}/user/changePassword`;
    console.log('url = ' + url);
  
    let body = JSON.stringify(resetPasswordRequestVO);
    return this.httpService.put(url, body).toPromise()
      .then(responseEnvelope => 
          console.log("Password Successfully changed")
         , error => {
        console.error("Error received in reset password service. " + JSON.stringify(error));
        throw error;
      });
  }
  
  getUserDetails(): Promise<UserVO> {
    let url = `${environment.SSO_API_ENDPOINT}/user/me`;
    
    return this.httpService.get(url).toPromise()
    .then(responseEnvelope => 
        {
          this.ssoService.updateUserDetails(responseEnvelope);
          console.log(responseEnvelope);
          return responseEnvelope;
        }
       , error => {
      console.error("Error received in get user details service. " + JSON.stringify(error));
      throw error;
    });
  }
  
  editUser(userVO: UserVO): Promise<UserVO> {
    let url = `${environment.SSO_API_ENDPOINT}/user/me`;
    console.log('url = ' + url);

    let body = JSON.stringify(userVO);
    return this.httpService.put(url, body).toPromise()
      .then(responseEnvelope => {
          console.log("User updated");
          return responseEnvelope;
      }
         , error => {
        console.error("Error received in edit user service. " + JSON.stringify(error));
        throw error;
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/profile/profile.service.impl.ts